export default __webpack_public_path__ + "static/media/beast.9f2dacb9.webp";